import React, { useCallback } from 'react';
import { SectionPanel } from 'ui';
import { SecondaryTextMode, TranslationsComponent } from 'app/components/translation';
import { MetroLineSection } from 'app/components/metro-line/metro-line-section';
import { SubscriberGroupSectionType } from '../metroline/types';
import { languageValidationParameter, longDescriptionValidationParameter, maxDescriptionLength } from '../constants';
import { SubscriberGroupLanguageProps } from '../types';

export const SubscriberGroupLanguage: React.FC<SubscriberGroupLanguageProps> = ({
  language, longDescription, mainLanguage, languageOptions, showTranslations, validation, translation, section,
  requiredLongDescription, getRef, switchTranslationsToggle, shouldRenderSection, changeLanguage, copyLanguageToAll,
  changeLongDescription, copyLongDescriptionToAll
}) => {

  const copyDescriptionToAll = useCallback(() => {
    copyLanguageToAll(mainLanguage, translation.copied_description_to_all);
  }, [mainLanguage, translation]);

  const copyLongDescription = useCallback(() => {
    copyLongDescriptionToAll(mainLanguage, translation.copied_long_description_to_all);
  }, [mainLanguage, translation]);

  return <MetroLineSection<SubscriberGroupSectionType>
    section={section}
    sectionType={SubscriberGroupSectionType.Translations}
    getRef={getRef}
    shouldRenderSection={shouldRenderSection}>
    <div ref={getRef(SubscriberGroupSectionType.Translations)}>
      <SectionPanel
        className="admin-paper-top-panel"
        componentId={SubscriberGroupSectionType.Translations}
        validation={undefined}
        info={{ text: translation.descriptions_and_translations }}
        label={{ visible: true, text: translation.descriptions_and_translations }} />
      <TranslationsComponent
        primaryText={language}
        secondaryText={longDescription}
        primaryTextValueKey={languageValidationParameter}
        secondaryTextValueKey={longDescriptionValidationParameter}
        primaryTextMaxLength={maxDescriptionLength}
        secondaryTextMaxLength={254}
        languageOptions={languageOptions}
        mainLanguage={mainLanguage}

        primaryTextLabel={translation?.description}
        copyPrimaryTextToAllLabel={translation?.copy_description_to_all}
        onPrimaryTextChange={changeLanguage}
        copyPrimaryTextToAllTranslations={copyDescriptionToAll}
        copySecondaryTextToAllTranslations={copyLongDescription}

        secondaryTextLabel={translation.long_description_title}
        secondaryTextInfo={requiredLongDescription
          ? translation.required_long_description
          : ''}

        copySecondaryTextToAllLabel={translation.copy_long_description_to_all}
        secondaryTextMode={SecondaryTextMode.normal}
        onSecondaryTextChange={changeLongDescription}

        translationsHeaderLabel={translation?.translations_header}
        switchTranslationsToggleLabel={translation?.show_translations}
        hasTranslationsToggled={showTranslations}
        switchTranslationsToggle={switchTranslationsToggle}
        readOnly={false}
        validation={validation?.language}
        validationLongDescription={validation?.longDescription} />
    </div>
  </MetroLineSection>;
};
